import { RedirectService } from './service/redirect.service';
import { Component , OnInit, Renderer2, ElementRef,ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import axios from "axios";
import { urls } from '../environments/environment_url'
import { Subscription, filter } from 'rxjs';
import { SeoService } from './service/seo.service';
import { debounce } from 'lodash-decorators';

import { Language } from './interfaces/language.interface';
import { LanguageService } from 'src/app/service/language/language.service';

// import { AxiosInstance } from "axios";
// Declare a tag for Analytics
declare let gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy{
  public checkProsses = false;
  title = 'angular-starter';
  searchValue: string;
  version = 'Angular version 12.2.7';
  about_menu_active=[]
  fint_btn_list:any=['Vehicle or motor','Part number','Cross reference']
  about_menu:any
  footer_text_menu:any=[{icon:{url:''},titlekey:{english:'',spanish:''},children:[{contentkey:{english:'',spanish:''}}]},
                        {icon:{url:''},titlekey:{english:'',spanish:''},children:[{contentkey:{english:'',spanish:''}}]},
                        {icon:{url:''},titlekey:{english:'',spanish:''},children:[{contentkey:{english:'',spanish:''}}]},
                        {titlekey:{english:'',spanish:''},children:[{icon:{url:'',name:''}}]}]
  icon_menu:any
  banner_cata:any
  findBtnState:any=0
  find_input_text:any=''
  find_input_value:any=''
  find_data:any
  sub_menu_state:any=0
  find_list:any=[]
  find_list1:any=[]
  find_list2:any=[]
  nav_search_list:any=[]
  BASE_URL = urls.BASE_URL
  sel_lang:any=''
  statusvehiclemotor = 'not-active';
  statuspartnumber = 'not-active';
  statuscroosreference = 'not-active';

  language_data!: Language[];
  showLang: boolean = false;
  @ViewChild('h6Partfindercontent') h6Partfindercontent!: ElementRef;
  @ViewChild('h6Partfindercontents') h6Partfindercontents!: ElementRef;
  @ViewChild('h6SearchbyCategory') h6SearchbyCategory!: ElementRef;
  @ViewChild('butPFVehicle') butPFVehicle!: ElementRef;
  @ViewChild('butPFCReference') butPFCReference!: ElementRef;
  @ViewChild('butPFPNumber') butPFPNumber!: ElementRef;
  @ViewChild('formSearchWeb') formSearch!: ElementRef;
  @ViewChild('btnPartFinder') btnPartFinder!: ElementRef;

  private subscription: Subscription;

  constructor(
    private languageService: LanguageService,
    private store: Store<{ lang: any }>,
    public router: Router,
    public renderer: Renderer2,
    private redirectService: RedirectService,
    private activatedRoute: ActivatedRoute,
    private seo: SeoService
    ) {
      this.searchValue = 'Search in web';
      store.select<any>('lang').subscribe(
        developers => this.sel_lang = developers
      );
      this.subscription = this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.init_lang();
        }
      });
  }
  setActivestatusvehiclemotor(){
    this.statusvehiclemotor = 'active-partfinder';
    this.statuspartnumber = 'not-active';
    this.statuscroosreference = 'not-active';
    this.find_list1 = [];
    this.find_list2 = [];
  }
  setActivestatuspartnumber(){
    this.statusvehiclemotor = 'not-active';
    this.statuspartnumber = 'active-partfinder';
    this.statuscroosreference = 'not-active';
    this.find_list = [];
    this.find_list2 = [];
  }
  setActivestatuscroosreference(){
    this.statusvehiclemotor = 'not-active';
    this.statuspartnumber = 'not-active';
    this.statuscroosreference = 'active-partfinder';
    this.find_list = [];
    this.find_list1 = [];
  }

  ngOnInit(): void {
    this.loadLanguage();
    this.init_menu();
    this.social_menu();
    this.footer_menu();
    this.setUpAnalytics();
    this.setUpSeo();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  init_lang(){
    axios.get(this.BASE_URL+'/public/language/mostrar-multilenguaje').then(response => {
      this.showLang=response.data.data;
      if(!this.showLang){
        localStorage.setItem('language','spanish')
        this.onChangeLang({target: {value : "spanish"}},false);
      }
      if(localStorage.getItem('language'))this.sel_lang=localStorage.getItem('language')
    });
  }

  init_menu(){
    axios.get(this.BASE_URL+'/public/layout/menu').then(response => {
      this.about_menu=response.data.data;
    });
  }

  loadLanguage(){
    const json:any = localStorage.getItem('languages_data');
    this.language_data = JSON.parse(json);

    if(!this.language_data || this.language_data == null){
      this.languageService.getLanguageService().then((response: { data: { data: Language[]; }; }) => {
        this.language_data = response.data.data;
        localStorage.removeItem('languages_data');
        localStorage.setItem('languages_data', JSON.stringify(this.language_data));
        this.translate();
      });
    }else{
      setTimeout(() => {
        this.translate();
      }, 0);
    }
  }

  translate(){
    const btnPartFinder = this.btnPartFinder.nativeElement;
    let btnPartFinderRender = this.languageService.findWordInLanguagesByFlag(btnPartFinder?.textContent, this.sel_lang, this.language_data);
    if (btnPartFinderRender) {
      btnPartFinderRender = this.renderer.createText(btnPartFinderRender);
      btnPartFinder.innerHTML = '';
      this.renderer.appendChild(btnPartFinder, btnPartFinderRender);
    }

    const h6Partfindercontent = this.h6Partfindercontent.nativeElement;
    let h6PartfindercontentRender = this.languageService.findWordInLanguagesByFlag(h6Partfindercontent?.textContent, this.sel_lang, this.language_data);
    if (h6PartfindercontentRender) {
      h6PartfindercontentRender = this.renderer.createText(h6PartfindercontentRender);
      h6Partfindercontent.innerHTML = '';
      this.renderer.appendChild(h6Partfindercontent, h6PartfindercontentRender);
    }

    const h6Partfindercontents = this.h6Partfindercontents.nativeElement;
    let h6PartfindercontentsRender = this.languageService.findWordInLanguagesByFlag(h6Partfindercontents?.textContent, this.sel_lang, this.language_data);
    if (h6PartfindercontentsRender) {
      h6PartfindercontentsRender = this.renderer.createText(h6PartfindercontentsRender);
      h6Partfindercontents.innerHTML = '';
      this.renderer.appendChild(h6Partfindercontents, h6PartfindercontentsRender);
    }

    const h6SearchbyCategory = this.h6SearchbyCategory.nativeElement;
    let h6SearchbyCategoryRender = this.languageService.findWordInLanguagesByFlag(h6SearchbyCategory?.textContent, this.sel_lang, this.language_data);
    if (h6SearchbyCategoryRender) {
      h6SearchbyCategoryRender = this.renderer.createText(h6SearchbyCategoryRender);
      h6SearchbyCategory.innerHTML = '';
      this.renderer.appendChild(h6SearchbyCategory, h6SearchbyCategoryRender);
    }

    const butPFVehicle= this.butPFVehicle.nativeElement;
    let butPFVehicleRender = this.languageService.findWordInLanguagesByFlag(butPFVehicle?.textContent, this.sel_lang, this.language_data);
    if (butPFVehicleRender) {
      butPFVehicleRender = this.renderer.createText(butPFVehicleRender);
      butPFVehicle.innerHTML = '';
      this.renderer.appendChild(butPFVehicle, butPFVehicleRender);
    }
    const butPFCReference= this.butPFCReference.nativeElement;
    let butPFCReferenceRender = this.languageService.findWordInLanguagesByFlag(butPFCReference?.textContent, this.sel_lang, this.language_data);
    if (butPFCReferenceRender) {
      butPFCReferenceRender = this.renderer.createText(butPFCReferenceRender);
      butPFCReference.innerHTML = '';
      this.renderer.appendChild(butPFCReference, butPFCReferenceRender);
    }

    const butPFPNumber= this.butPFPNumber.nativeElement;
    let butPFPNumberRender = this.languageService.findWordInLanguagesByFlag(butPFPNumber?.textContent, this.sel_lang, this.language_data);
    if (butPFPNumberRender) {
      butPFPNumberRender = this.renderer.createText(butPFPNumberRender);
      butPFPNumber.innerHTML = '';
      this.renderer.appendChild(butPFPNumber, butPFPNumberRender);
    }

   const searchValueRender = this.languageService.findWordInLanguages(this.searchValue, this.sel_lang, this.language_data);
   if(searchValueRender){
    this.searchValue = searchValueRender;
   }

}

  onFindClick(value:any){
    this.checkProsses = false;
    this.findBtnState = value
    this.find_input_text = ''
    this.find_list = []
  }
  onClose(e:any){
    this.find_input_text = ''
    this.find_list = [];
    this.find_list1 = [];
    this.find_list2 = [];
    this.checkProsses = false;
  }
  @debounce(500)
  onChange(e:any){
    if(e.target.value=='') {
      this.find_list = [];
      this.find_list1 = [];
      this.find_list2 = [];
      this.checkProsses = false;
      return;
    }
    switch (this.findBtnState){
      case 0:
        if(e.target.value=='' || e.target.value.length < 2)this.find_list = [],this.checkProsses = false;
        else axios.get(this.BASE_URL+'/public/part-finder/search-by-vehicle/'+e.target.value+'?lang='+ this.sel_lang).then(response => {
          this.find_list = response.data.data
          this.checkProsses = true;
          if(e.target.value=='')this.find_list = []
        });break;
      case 1:
        if(e.target.value=='' || e.target.value.length <= 2)this.find_list1 = [],this.checkProsses = false;
        else {
          e.target.value=e.target.value.toUpperCase();
          axios.get(this.BASE_URL+'/public/part-finder/search-by-part-number/'+e.target.value+'?lang='+ this.sel_lang).then(response => {
          this.find_list1 = response.data.data
          this.checkProsses = true;
          if(e.target.value=='')this.find_list1 = []

        });
        }break;
      case 2:
        if(e.target.value=='' || e.target.value.length <= 3)this.find_list2 = [],this.checkProsses = false;
        else {
          e.target.value=e.target.value.toUpperCase();
          axios.get(this.BASE_URL+'/public/part-finder/search-by-cross-reference/'+e.target.value+'?lang='+ this.sel_lang).then(response => {
          this.find_list2 = response.data.data
          this.checkProsses = true;
          if(e.target.value=='')this.find_list2 = []
        });
        }
        break;
    }
  }

  async onClickSearchList(idProduct:any){
    this.find_list=[]
    let jsonData: any = {
      isByCategory: false,
      breadCrumb: this.find_input_text
    };
    localStorage.setItem('partFinderDetailData', JSON.stringify(jsonData));
    let url = '/part-finder/busqueda-rapida/detalles/'+ idProduct;
    /* this.router.navigate(['/part-finder/busqueda-rapida/detalles/'+ idProduct]); */
    this.find_input_text = '';
    this.router.navigateByUrl('/', {skipLocationChange: true}).then( () =>
      this.router.navigate([url])
    );
  }

  onNavSearchChange(e: any){
    /* await axios.get(this.BASE_URL+'/public/layout/search-in-web/'+ lang + '/'+e.target.value).then(response => {
          if(e.target.value!='')this.nav_search_list = response.data.data
          else this.nav_search_list = {AUTO:{AutomovilBobina:[]}}
          console.log(this.nav_search_list)
          this.router.navigate(['search-result'],{state:{data:this.nav_search_list, keyword:e.target.value}});
        }); */
    if (e == undefined || e.target.value == undefined) {
      return;
    }
    let value: string = e.target.value;
    if (!value || value.trim().length == 0) {
      return;
    }
    //this.router.navigateByUrl('buscador-web/' + this.sel_lang + '/' + value);
    this.router.navigateByUrl('/buscador-web', {skipLocationChange: true}).then( () =>
      this.router.navigate(['buscador-web/' + this.sel_lang + '/' + value])
    );
    this.formSearch.nativeElement.reset();
  }

  async onInputEnter(event: any){
    /* console.log(event);
    await axios.get(this.BASE_URL+'/public/part-finder/search-by-vehicle/'+this.find_input_text).then(response => {
      this.find_data = response.data.data
      console.log('this.find_data:  ', this.find_data)
      this.router.navigate(['/part-finder/busqueda-rapida/detalles'],{state:this.find_data});
    }); */
  }

  onChangeLang(e:any, reload: boolean){
    this.languageService.getLanguageService().then((response: { data: { data: Language[]; }; }) => {
      localStorage.removeItem('languages_data');
      localStorage.setItem('languages_data', JSON.stringify(response.data.data));
    });

    const lang = e.target.value;

    this.store.dispatch({
      type: 'LANGUAGE',
      payload: lang
    });

    localStorage.setItem('language', lang);

    if(reload){
      setTimeout(() => {
        window.location.reload();
      }, 800);
    }
  }

  hoverIn(v:any){
    this.sub_menu_state=v+1
    //console.log(this.sub_menu_state)
  }

  hoverOut(v:any){
    this.sub_menu_state=0
    //console.log(this.sub_menu_state)
  }

  footer_menu(){
    axios.get(this.BASE_URL+'/public/layout/footer').then(response => {
      this.footer_text_menu = response.data.data
      //console.log("Footer",this.footer_text_menu)
    });
  }

  printImageFooter(icon: any): string{
    const urlDefault = "assets/params/images/demo/Group_205.png";
    return icon != undefined || icon != null ?
           icon.url != undefined || icon.url != null ?
           icon.url :  urlDefault : urlDefault;
  }

  social_menu(){
    axios.get(this.BASE_URL+'/public/layout/social-media').then(response => {
      this.icon_menu = response.data.data
      //console.log(this.icon_menu)
    });
  }

  onSelectMenu(link: any): void {
    const element = document.getElementById('bd-docs-nav');
    this.renderer.removeClass(element, 'show');
    const route = '/' + link;
    this.router.navigate([route]);
  }

  setUpAnalytics() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        if (event instanceof NavigationEnd) {
          gtag('config', 'UA-218812235-1',
            {
              page_path: event.urlAfterRedirects
            }
          );
        }
      });
  }

  setUpSeo() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        const data: any = route.snapshot.data || {};
        this.seo.apply({
          title: data.title,
          description: data.description,
          keywords: data.keywords,
          image: data.image
        });
      });
  }

  validateURL(url: string) {
    this.redirectService.redirectToURL(url);
  }

  onRedirect(url:string){
    if(/^http[s]?/.test(url)){
      this.router.ngOnDestroy();
      window.open(url, '_blank');
    }else {
      this.router.navigate([url]);
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
  }
}

